import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Signin from './components/signin/Signin'
import ForgotPassword from './components/signin/ForgotPassword'
import ForgotPin from './components/signin/ForgotPin'
import SignUp from './components/signup/SignUp'
import GiveOnline from './components/checkout/GiveOnline'
import './assets/css/main.css'
import Topbar from './components/Layout/Topbar';
import Footer from './components/Layout/Footer';
import Verification from './components/verification/Verification';
import Store from './store/Store'
import SuccessErrorPage from './components/SuccessErrorPage'

function App() {
  const [orgData, setOrgData] = useState({});
  const [signUpSource, setSignUpSource] = useState('');
  let orgColors = {
    background: orgData.orgPrimaryColor ? orgData.orgPrimaryColor : '#272f46',
    secondary:  orgData.orgSecondaryColor ? orgData.orgSecondaryColor : '#222',
    accent:  orgData.orgAccentColor ? orgData.orgAccentColor : '#efefef',
  }
  const unicycle = 'cpGridKonnect12';
  const pencil = 'L1feStyle2WEalth#5161';

  const urlParams = window.location.hostname;
  // axios.get(`https://api.churchpad.com/p/org-info/?orgDomainName=${'test.churchpad.com'}`, {
  let getOrgData = () => {
    let tok =  btoa(`${unicycle}:${pencil}`)
    // axios.get(`https://api.churchpad.com/p/org-info/?orgDomainName=${'wcima.churchpad.com'}`, {
    axios.get(`https://api.churchpad.com/p/org-info/?orgDomainName=${urlParams}`, {
        // Axios looks for the `auth` option, and, if it is set, formats a
        // basic auth header for you automatically.
        headers : { 'Authorization' : `Basic ${tok}` }
    }).then(res => {
        console.log(res.data)
        let data = res.data.responseCode === '00' ? res.data.responseData : false;
        setOrgData(data);
    }).catch((err) => {
        console.log(err);
    })
  }


  // let getQueryParams = () => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   let params = urlParams.toString();
  //   params = params.split('=');
  //   // console.log(params);
  //   if(params[0] !== 'type') {
  //       window.location = '/';
  //   } else if(!(params[1] === 'checkin' || params[1] === 'rsvp')) {
  //       window.location = '/';
  //   }
  //   return params[1];
  // }

  useEffect(() => {
    getOrgData();
  }, [])

  //Add orgAllowWebCheckIn, orgAllowWebRsvp

  return (
    <Store>
      <div className="App">
        <div className="main-container">
          <div className="main">
            <div className="headerColor" style={{backgroundColor: orgColors.background}}></div>
            <Router>
              <Topbar
                colors={{...orgColors}}
                navData={{
                  logo:orgData.orgLogo,
                  orgFullName: orgData.orgFullName,
                  churchWebsite: orgData.orgChurchPadUrl,
                }}
                orgMessagingNumberLabel={orgData.orgMessagingNumberLabel}
                orgMessagingNumberValue={orgData.orgMessagingNumberValue}
                allowRsvp={orgData.orgAllowWebRsvp === '1' ? true : false}
                allowCheckIn={orgData.orgAllowWebCheckIn === '1' ? true : false}
                rsvpLabel={orgData.orgWebRsvpLabel}
              />
              <Switch>
                <Route exact path='/cp'>
                  <Signin
                    colors={{...orgColors}}
                    orgId={orgData.orgId}
                    unicycle={unicycle}
                    pencil={pencil}
                  />
                </Route>

                <Route exact path='/cp/signin'>
                  <Signin
                    colors={{...orgColors}}
                    orgId={orgData.orgId}
                    unicycle={unicycle}
                    pencil={pencil}
                  />
                </Route>

                <Route exact path='/cp/forgot-password'>
                  <ForgotPassword
                    colors={{...orgColors}}
                    orgId={orgData.orgId}
                    unicycle={unicycle}
                    pencil={pencil}
                  />
                </Route>
                
                <Route exact path='/cp/forgot-pin'>
                  <ForgotPin
                    colors={{...orgColors}}
                    orgId={orgData.orgId}
                    unicycle={unicycle}
                    pencil={pencil}
                  />
                </Route>

                <Route exact path='/cp/signUp'>
                  <SignUp
                    colors={{...orgColors}}
                    orgId={orgData.orgId}
                    signUpSource={signUpSource}
                    unicycle={unicycle}
                    pencil={pencil}
                  />
                </Route>

                <Route exact path='/cp/give-online'>
                  {
                    orgData.orgPaymentGatewayStatus === '0' ? 
                    <SuccessErrorPage
                      colors={{...orgColors}}
                      orgId={orgData.orgId}
                      type={'generic'}
                      message={orgData.orgPaymentGatewayMessage}
                    /> :
                     <GiveOnline
                      colors={{...orgColors}}
                      orgId={orgData.orgId}
                      maxDonation={orgData.orgMaximumDonationAmount}
                      minDonation={orgData.orgMinimumDonationAmount}
                      allowedCardOptions={orgData.orgAllowedCardsOptions ? orgData.orgAllowedCardsOptions : false}
                      allowsCheck={orgData.orgAllowCheckAch === 'yes' ? true : false}
                      give_frequency={orgData.orgRecurringOptions ? orgData.orgRecurringOptions : []}
                      giving_type={orgData.orgContributionTypeOptions ? orgData.orgContributionTypeOptions : []}
                      currency={orgData.orgCurrency3LetterCode}
                      unicycle={unicycle}
                      pencil={pencil}
                    />
                  }
                </Route>

                <Route exact path='/cp/checkin'>
                  <Verification
                    colors={{...orgColors}}
                    orgId={orgData.orgId}
                    pencil={pencil}
                    unicycle={unicycle}
                    type={'checkin'}
                  />
                </Route>

                <Route exact path='/cp/rsvp'>
                  <Verification
                    colors={{...orgColors}}
                    orgId={orgData.orgId}
                    pencil={pencil}
                    unicycle={unicycle}
                    type={'rsvp'}
                    rsvpLabel={orgData.orgWebRsvpLabel}
                  />
                </Route>
              </Switch>
            </Router>
            <Footer
              data={{
                email: orgData.orgContactEmail,
                phoneNumber: orgData.orgContactNumber,
                orgFullName: orgData.orgFullName,
                website: orgData.orgChurchPadUrl,
                contactWeb: orgData.orgContactWeb,
                address: orgData.orgMailingAddress,
                privacy: orgData.orgPrivacyPolicyUrl,
                tos: orgData.orgTermsOfServiceUrl,
                orgMessagingNumberLabel: orgData.orgMessagingNumberLabel,
                orgMessagingNumberValue: orgData.orgMessagingNumberValue,
                social: {
                  twitter: orgData.orgTwitter,
                  youtube: orgData.orgYouTube,
                  instagram: orgData.orgInstagram,
                  facebook: orgData.orgFacebook
                }
              }}
            />
          </div>
        </div>
      </div>
    </Store>
  );
}

export default App;
